let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b2jr8")).then(() => parcelRequire('bpHW7'));